import React from 'react';
import {
  insertNodes,
  ELEMENT_HR,
  ELEMENT_DEFAULT,
} from '@udecode/plate';
import { useEditorRef, focusEditor, useEventPlateId } from '@udecode/plate-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import { ToolbarButton } from './ToolbarButton';

export const HrButton = ({ id, ...props }) => {
  const editor = useEditorRef(useEventPlateId(id));

  return (
    <ToolbarButton
      name="Insert line"
      className={clsx('button--unstyled')}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        insertNodes(
          editor,
          [
            { type: ELEMENT_HR, children: [{ text: '' }] },
            { type: ELEMENT_DEFAULT, children: [{ text: '' }] },
          ],
        );
        setTimeout(() => {
          focusEditor(editor);
        }, 0);
      }}
      onMouseDown={(e) => e.preventDefault()}
      {...props}
    >
      <FontAwesomeIcon icon={['fa', 'horizontal-rule']} />
    </ToolbarButton>
  );
};
